var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.522 2.40742C21.2686 1.46617 20.5264 0.724037 19.5852 0.470624C17.8656 0 10.9873 0 10.9873 0C10.9873 0 4.10891 0 2.38932 0.452523C1.46617 0.705936 0.705936 1.46617 0.452523 2.40742C0 4.12701 0 7.69289 0 7.69289C0 7.69289 0 11.2769 0.452523 12.9784C0.705936 13.9196 1.44807 14.6617 2.38932 14.9152C4.12701 15.3858 10.9873 15.3858 10.9873 15.3858C10.9873 15.3858 17.8656 15.3858 19.5852 14.9333C20.5264 14.6798 21.2686 13.9377 21.522 12.9965C21.9745 11.2769 21.9745 7.71099 21.9745 7.71099C21.9745 7.71099 21.9926 4.12701 21.522 2.40742Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79712 4.39844V10.9872L14.517 7.69281L8.79712 4.39844Z",
    fill: "#2B5F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube2);
export default __webpack_public_path__ + "static/media/youtube 2.d274f8bcefeb9791374a405c00d4c9c6.svg";
export { ForwardRef as ReactComponent };